import { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import { Field as FinalFormField } from 'react-final-form';
import { Field as ReduxFormField } from 'redux-form';
import Row from 'react-bootstrap/lib/Row';
import Col from 'react-bootstrap/lib/Col';
import elementType from 'prop-types-extra/lib/elementType';
import { pick, keys, omit } from 'lodash/fp';
import Control from '../Control';
import cn from './styles.local.less';

const getColProps = pick(keys(Col.propTypes));

export default class Field extends PureComponent {
  static propTypes = {
    type: PropTypes.string.isRequired,
    Box: elementType,
    renderCol: PropTypes.func,
    withRow: PropTypes.bool,
    isReactFinalForm: PropTypes.bool,
  };

  static defaultProps = {
    withRow: true,
    renderCol: ({ colProps }) => <Col {...colProps} />,
  };

  renderContainer = (children) => {
    const { withRow } = this.props;

    if (withRow) {
      return <Row className={cn.row} {...children} />;
    }

    return <Fragment {...children} />;
  };

  renderBox = (boxProps) => {
    const { className, inputNode, iconNode, labelNode, input, value } =
      boxProps;
    const { Box, type, renderCol } = this.props;
    const colProps = getColProps(this.props);

    const children = Box ? (
      <Box {...boxProps} />
    ) : (
      <label className={className} data-qa-value={value}>
        {inputNode}
        {iconNode}
        {labelNode}
      </label>
    );

    return renderCol({
      colProps: {
        'xs': 12,
        ...colProps,
        'data-qa-selector': type,
        children,
      },
      input,
    });
  };

  renderComponent = (props) => {
    const { type } = this.props;

    return <Control {...props} type={type} />;
  };

  render() {
    const props = omit(['type', 'withRow'], this.props);
    const FormField = this.props.isReactFinalForm
      ? FinalFormField
      : ReduxFormField;

    return (
      <FormField
        Container={this.renderContainer}
        {...props}
        component={this.renderComponent}
        Box={this.renderBox}
      />
    );
  }
}
